export default "__VITE_ASSET__DdF1CzC8__"